import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { StringMatchServiceImpl } from './string-match-service';
import { StringMatchService } from './types/string-match-service.interface';
import { FormatNumberService } from './types/format-number-service.interface';
import { FormatNumberServiceImpl } from './format-number-service';
import { FormatDateService } from './types/format-date-service.interface';
import { FormatDataServiceImpl } from './formate-date-service';
export const utils = new ContainerModule((bind) => {
    bind(StringMatchService).to(StringMatchServiceImpl);
    bind(FormatNumberService).to(FormatNumberServiceImpl);
    bind(FormatDateService).to(FormatDataServiceImpl);
});
